//--------------- IMPORTAÇÕES ---------------//
import api from "../../../shared/services/api";
import { toast } from "react-toastify";
import { TrackingContext } from "../context/TrackingContext";
import { useContext } from "react";



//--------------- FUNÇÃO ASSÍNCRONA SALVAR EMPRESA ---------------//
// Responsável por salvar a empresa criada via API
export default async function loadTrackingService(startDate, endDate) {
    
    try {

        // const {groupProductsFilter, setGroupProductsFilter} = useContext(TrackingContext);


        // grupo = groupProducts.filter(group => group.id == groupProductsFilter)[0]
        // let produtos = [];
        // if (groupProducts != null) {
        //     console.log("ENTROU NO IF DE PRODUTOS: ", groupProducts)
        //     grupo.produtos.map((produto) => {
        //         produtos.push(produto.id);
        //     });
        // } else if (produtos == [])   {
        //     produtos = null;
        // }


        const response = await api.post(`/tracking-relatorio`, {
            start: startDate,
            end: endDate,
        });
        toast.success("Tracking carregado com sucesso")
        return response;
    } catch (error) {
        toast.error("Erro ao carregar Tracking");
        return null;
    }
}